module.exports = "img/notif-active.6d534cc.svg";